export const getTravelMainColorState = (stateSummary: string | null) => {
  if (stateSummary === STATUS_SUMMARY.CONFIRMED) {
    return 'text-pink-500'
  }
  if (stateSummary === STATUS_SUMMARY.CONFIRMED) {
    return 'text-peacock-500'
  }
  if (stateSummary === STATUS_SUMMARY.CONFIRMED) {
    return 'text-yellow-500'
  }
  return 'text-black'
}
